/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-18",
    versionChannel: "nightly",
    buildDate: "2025-06-18T00:06:45.477Z",
    commitHash: "9095cdec7df2fce3058bd77d2908687c069d27e4",
};
